
import { useState, useCallback , useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Container, useTheme, TableContainer, Card, Table, TableBody, Button, Tabs, Tab, alpha} from '@mui/material';
import { useSettingsContext } from '../../components/settings/index.js';
import {useTable, TableHeadCustom, TablePaginationCustom} from '../../components/table/index.js';
import CustomBreadcrumbs from '../../components/custom-breadcrumbs/index.js';
import {RouterLink} from '../../routes/components/index.js';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../components/snackbar/index.js';
import Iconify from '../../components/iconify/iconify.js';
import SubscriptionTableRow from './subscription-table-row.js';
import SubscriptionTableToolBar from './subscription-table-toolbar.js';
import Label from '../../components/label/index.js';


// GRAPHQL
import { GET_ALL_SUBSCRIPTION, DELETE_SUBSCRIPTION } from "../../graphql/modules/subscription.js";
import { useQuery, useMutation } from "@apollo/react-hooks";

const STATUS_OPTION = [
  {value: 'all', label: 'All'},
  // {value: 'Enhanced', label: 'Enhanced'},
  // {value: 'Standard', label: 'Standard'},
  // {value: 'Avanced', label: 'Avanced'}
]
const TABLE_HEAD = [
  {id: 'title', label: 'Subscription'},
  {id: 'amount', label: 'Amount'},
  {id: 'details', label: 'Details'},
  {id: 'dateCreated', label: 'Date Created'},
  {id: 'dateModified', label: 'Date Modified'},
  {}
]

const defaultFilters = {
  name: '',
  subscription: [],
  status: 'all'
}

export function SubscriptionListView({img, ...other}) {
  const {fullName} = useSelector((state) => state?.auth?.user);
  const theme = useTheme();
  const table = useTable();
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const [filters, setFilters] = useState('all');
  const [searchText, setSearch] = useState("");
  const [companyName, setCompanyName] = useState("iatos");
  const [page, setPage] = useState(1);
  const [results, setResults] = useState(null);
  const [DeleteSubscriptionMutation] =  useMutation(DELETE_SUBSCRIPTION);
  const { enqueueSnackbar } = useSnackbar();
  const { data, loading, error, refetch } = useQuery(GET_ALL_SUBSCRIPTION, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: searchText,
      companyName: companyName,
      order: table.order,
      orderBy: table.orderBy || 'createdDate'
      },
      fetchPolicy: "cache-and-network",
    });

 

    useEffect(() => {
        if(data){
          setResults(data?.getAllSubscription)
        }
    }, [data])

    const handleFilters = useCallback((name, value) => {
      setSearch(value)
    },
    [table]
  );
  
    const handleDeleteRow = useCallback(async (id) => {
      const {data: { deleteSubscription }} = await DeleteSubscriptionMutation({
        variables: {
          _id: id,
          companyName: "iatos",
          fullName: fullName
        }
      })
    
      if(deleteSubscription?.success){
        enqueueSnackbar('Deleted success!', {variant: 'success'});
        refetch();
      }else {
        enqueueSnackbar('Failed to delete!', {variant: 'error'});
      }
      },
      [refetch]
    );
  

  const handleViewAccount = useCallback((row) => {
      navigate('/subscription-details', {state: row})
    },
    []
  );
  const handleEditRow = useCallback((row) => {
      navigate('/subscription-create-update', {state: row})
  });

  const handleFilterStatus = useCallback(
    (event, newValue) => {
      if(newValue !== "all"){
        setFilters(newValue);
        setSearch(newValue);
      }else {
        setFilters(newValue);
        setSearch('');
      }
  
    },
    [table]
  );


  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <CustomBreadcrumbs
         heading="Subscription List"
         links={[
          {name: 'Dashboard'},
          {name: 'Subscription'},
          {name: 'List'}
         ]}
         action ={
          <Button
          componet={RouterLink}
          href={'/subscription-create-update'}
          variant="contained"
          startIcon={<Iconify icon="mingcure:add-line" />}
          >
            New Subscription
          </Button>
         }
        />


        <Card>
         <Tabs 
          value={filters}
          onChange={handleFilterStatus}
          sx={{
            px: 2.5,
            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`
          }}
         >
          {STATUS_OPTION.map((tab) => (
            <Tab
              key={tab?.value}
              iconPosition='end'
              value={tab?.value}
              label={tab?.label}
              icon={
              <Label 
                variant={
                  ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                }
                color={
                  (tab.value === 'Enchanced' && 'success') ||  (tab.value === 'Standard' && 'info') ||  (tab.value === 'Avanced' && 'warning') || 'default'
                }
                >
                  {tab.value === 'all' && results?.count}
                  {tab.value === 'Enchanced' && results?.results?.filter((res) => res.title === 'Enchanced').length}
                  {tab.value === 'Standard' && results?.results?.filter((res) => res.title === 'Standard').length}
                  {tab.value === 'Avanced' && results?.results?.filter((res) => res.title === 'Avanced').length}
              </Label>
              }
           />
  
          ))}

         </Tabs>

          <SubscriptionTableToolBar onFilters={handleFilters}/>

          <TableContainer sx={{ position: 'relative', overflow: 'unset'}}>
              <Table  sx={{minWidth: 960}}>
                
              <TableHeadCustom
                headLabel={TABLE_HEAD}
                order={table.order}
                orderBy={table.orderBy}
                onSort={table.onSort}
              />
  

   
                <TableBody>

                {results?.results?.map((row) => (
                      <SubscriptionTableRow
                      key={row?.id}
                      row={row}
                      onViewRow={() => handleViewAccount(row)}
                      onDeleteRow={() => handleDeleteRow(row._id)}
                      onEditRow={() => handleEditRow(row)}
                    />
                ))}
  

                </TableBody>

              </Table>
          </TableContainer>

          <TablePaginationCustom 
            count={results?.count}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            dense={table.dense}
            onChangeDense={table.onChangeDense}
          />
        </Card>

    </Container>
  );
}